/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContentIssue} from "./contentIssue.zod";
import {EvaluatedCatalogBlock} from "./evaluatedCatalogBlock.zod";
import {OfferExchangeRates} from "./offerExchangeRates.zod";
import {ResolvedOfferVariable} from "./resolvedOfferVariable.zod";

export const TemplateEvaluation = zod
  .object({
    exchangeRates: OfferExchangeRates,
    catalogBlocks: zod.array(EvaluatedCatalogBlock),
    variables: zod.array(ResolvedOfferVariable),
    issues: zod.array(ContentIssue),
  })
  .describe("Source preview without Expedient-dependent finances.");

export type TemplateEvaluation = zod.input<typeof TemplateEvaluation>;
export type TemplateEvaluationOutput = zod.output<typeof TemplateEvaluation>;
